<template>
  <div class="d-flex flex-column align-center text-center">
    <v-img width="100%" contain :src="logo.full"></v-img>
    <v-card v-if="showTestimonial" class="auth-hero-card rounded-lg mt-6" variant="flat">
      <v-card-text class="py-6 text-center">
        <v-avatar size="52" class="mb-3">
          <v-img :src="testimonialSrc"></v-img>
        </v-avatar>
        <p class="auth-hero-card-text mb-2" v-html="highlightedTestimonialText"></p>
        <span class="auth-hero-card-caption text-accent-color">{{ testimonialRole }}</span>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import logoSrc from '@/assets/icons/branding/dark/cf-dark-new.png'
import defaultTestimonialSrc from '@/assets/images/auth/testimonial2.png'

export default {
  props: {
    showTestimonial: {
      type: Boolean,
      default: true
    },
    testimonial: {
      type: Object,
      default: () => ({
        mg: '',
        role: '',
        img: ''
      })
    }
  },
  data() {
    return {
      logo: {
        full: logoSrc,
        testimonial: defaultTestimonialSrc
      }
    }
  },
  computed: {
    testimonialSrc() {
      return this.testimonial.img || this.logo.testimonial
    },
    testimonialText() {
      return this.testimonial.mg || 'I had a fantastic experience. I set up a free trial & practice a little bit on the forms. I was able to customize my form & get it in my site within a few short days. I highly recommend CliqForms, they are very professional, courteous, and very timely in their service & I would encourage you to work with them in the very near future.'
    },
    highlightedTestimonialText() {
      return this.testimonialText.replace(/CliqForms/gi, '<em>CliqForms</em>')
    },
    testimonialRole() {
      return this.testimonial.role || 'John Pitlic, TalkingVCard Founder'
    }
  }
}
</script>
